export default __webpack_public_path__ + "static/media/33.f4f5feb0.png";